/**
 * 색상 관련 유틸리티
 * 아바타 배경색 및 팀 색상 관리
 */

/**
 * 색상 이름을 실제 CSS 색상으로 변환
 * @param colorName 색상 이름
 * @returns CSS 색상 값
 */
export const getBackgroundColor = (colorName: string): string => {
  const colorMap: { [key: string]: string } = {
    'PastelBlue': '#B3D9FF',
    'PastelGreen': '#B3FFB3',
    'PastelYellow': '#FFFFB3',
    'PastelRed': '#FFB3B3',
    'PastelPurple': '#E6B3FF',
    'PastelOrange': '#FFD9B3',
    'PastelPink': '#FFB3E6',
    'PastelCyan': '#B3FFFF',
    'Light': '#F5F5DC',
    'Dark': '#8B4513',
    'Brown': '#A0522D',
    'Black': '#2C2C2C',
    'White': '#FFFFFF',
    'Gray': '#808080'
  };
  
  return colorMap[colorName] || '#B3D9FF'; // 기본값: PastelBlue
};

/**
 * 팀 색상 매핑
 */
const TEAM_COLORS = {
  '': 'rgba(255,255,255,0.85)',
  'A': 'rgba(244,67,54,0.2)',
  'B': 'rgba(255,152,0,0.2)',
  'C': 'rgba(255,235,59,0.2)',
  'D': 'rgba(76,175,80,0.2)',
  'E': 'rgba(33,150,243,0.2)',
  'F': 'rgba(63,81,181,0.2)',
  'G': 'rgba(156,39,176,0.2)',
  'H': 'rgba(158,158,158,0.2)'
} as const;

/**
 * 팀 배경색 반환
 * @param team 팀 이름
 * @returns 팀 배경색
 */
export const getTeamBg = (team?: string): string => {
  return TEAM_COLORS[String(team || '') as keyof typeof TEAM_COLORS] ?? 'rgba(255,255,255,0.85)';
};

/**
 * 팀 배경색 반환 (별칭)
 * @param team 팀 이름
 * @returns 팀 배경색
 */
export const getTeamBgColor = (team?: string): string => {
  return getTeamBg(team);
};


